import { Activity, ActivityTriggerActionEnum, ParcelRecapStatus, Receiver, Remittance } from "generated/graphql";
import React from "react";
import { Advantage } from "../../generated/graphql";

export type CashcardProps = {
    count?: string | number;
    amount?: string | number;
    status?: string;
    clickAction?: () => void;
    activeCard?: number;
    identifier?: number;
    isParcelCount?:boolean;
    isRmittance?:boolean;
  }
  export type HistoryType = {
    activities:Activity[]
  }

  export interface IconProps {
    height?: string | number;
    width?: string | number;
    color?: string;
  }

  export interface HeadProps {
    setSearchTerm?: React.Dispatch<React.SetStateAction<string>>;
    searchTerm?:string;
    buttonClick?:React.Dispatch<React.SetStateAction<boolean>>;
    cashQuery?: FilterForm;
    clearFilter?(activeStatus?:string):void;
    title?:string;
  }

  export type FilterForm = {
    from: string;
    to: string;
    receiver:Receiver
  };

  export interface FilterRecapParcelProps {
    onClose?(): void;
    onConfirm?(): void;
    open: boolean;
    setHasFilters?: React.Dispatch<React.SetStateAction<boolean>>;
    cashQuery?: FilterForm;
    setCashQuery?: React.Dispatch<React.SetStateAction<FilterForm>>;
    parcelIds?: string[];
    remittanceUid?:string;
    url?:string;
    clientID?:string;
    isReceiver?:boolean;
    
  }

  export interface displayFileProps {
    onClose(): void;
    onConfirm?(): void;
    open: boolean;
    files?: string[];
  }

  export interface IAdvantageModal {
    onClose(): void;
    onConfirm?(): void;
    open: boolean;
    endDate?: string,
    advantage: Advantage,
    clientId?:string
  }

  export interface confirmProps {
    onClose(): void;
    onConfirm?(): void;
    open: boolean;
    reason?:string;
    setReason?: React.Dispatch<React.SetStateAction<string>>;
    isConfirm?:boolean
    
  }

  export const defaultFilterValues: FilterForm = {
    from: null,
    to: null,
    receiver :null
  };

  export type RemittanceDetailProps = {
    remittance?: Remittance,
    setRemittanceDetails:React.Dispatch<any>
    setActiveCard: React.Dispatch<React.SetStateAction<number>>
    setRemittanceStatus: React.Dispatch<React.SetStateAction<string>>
  }

  export enum SpecialZoomLevel {
    ActualSize = 'ActualSize',
    PageFit = 'PageFit',
    PageWidth = 'PageWidth',
}


export const cashRecapPageStatuts : ParcelRecapStatus[] = [
  ParcelRecapStatus?.AllCashCollected,
  ParcelRecapStatus?.YetToCollect, 
  ParcelRecapStatus?.FailedToCollect,
  ParcelRecapStatus?.RemittanceInHouse,
  ParcelRecapStatus?.RemittanceConfirmed
];


export const getActivityDescription = (
  activity_trigger_action: string,
  activity_trigger_action_data_reason: string,
  text: any
) => {
  const activityDescriptions = {
    [ActivityTriggerActionEnum.Created]: text.cash_management.created_by_ops_agent,
    [ActivityTriggerActionEnum.ReceivedByClient]: text.cash_management.received_by_client,
    [ActivityTriggerActionEnum.NotReceivedByClient]: text.cash_management.not_received_by_client,
    [ActivityTriggerActionEnum.ParcelAdded]: text.cash_management.parcels_added_by_ops_agent,
    [ActivityTriggerActionEnum.ParcelDeleted]: text.cash_management.parcels_deleted_by_ops_agent,
    [ActivityTriggerActionEnum.ResendByOps]: text.cash_management.resend_remittance,
  };
  return activity_trigger_action_data_reason || activityDescriptions[activity_trigger_action];
};

export type HistoryItemProps = {
  activity:Activity,
  identifier:number,
  text: any,
}

export enum fileExtension {
  PDF = "pdf",
  PNG = "png",
  JPEG = "jpeg",
  JPG = "jpg",
}
  
